import * as Yup from "yup";

// define your fields
export const initialValues = {mobile: "", firstName: "", lastName: "", password: "", confirmPassword: "", referenceCode: "", validateReferencerCode: false};
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

// define validation rules
export const validationSchema = Yup.object({
    mobile: Yup.string().required("موبایل را وارد کنید").min(10, "موبایل باید حداقل شامل 3 کاراکتر باشد").max(11, "موبایل باید حداقل شامل 11 کاراکتر باشد").matches(phoneRegExp, 'شماره موبایل نا معتبر'),
    firstName: Yup.string().required("نام را وارد کنید").min(3, "نام باید حداقل شامل 3 کاراکتر باشد"),
    lastName: Yup.string().required("نام خانوادگی را وارد کنید").min(3, "نام خانوادگی باید حداقل شامل 3 کاراکتر باشد"),
    referenceCode: Yup.string().required("کد معرف را وارد کنید"),
    password: Yup.string().required("رمز عبور را وارد کنید").min(8, "رمز عبور باید حداقل شامل ۸ کاراکتر باشد"),
    confirmPassword: Yup.string().oneOf([Yup.ref("password"), ""], "رمز عبور را مجددا وارد کنید").required("رمز عبور هم خوانی ندارد"),
    // terms: Yup.boolean().oneOf([true], "شما باید قبل از ثبت نام با قوانین موافقت کنید"),
    validateReferencerCode: Yup.boolean().oneOf([true], "کد کاربری معتبر نمی باشد")
})